export default __webpack_public_path__ + "static/media/sam-and-karen-airplane.a495d6a2.jpeg";